var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDungeonInfoModalBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 468,
    viewBox: "0 0 359 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.5 467.499C117.351 467.499 56.5289 448.835 8.17918 414.924L0.456055 409.502V0.638428H358.544V409.52L350.821 414.943C302.492 448.835 241.649 467.518 179.5 467.518V467.499Z",
    fill: "url(#paint0_linear_815_8926)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.505 459.755C119.388 459.755 60.5556 441.704 13.7889 408.907L9.38184 405.806V8.36365H349.649V405.806L345.242 408.907C298.475 441.704 239.642 459.755 179.526 459.755H179.505Z",
    fill: "url(#paint1_linear_815_8926)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.501 447.263C123.135 447.263 67.8901 431.619 23.0776 403.109V20.8557H335.925V403.089C291.112 431.6 235.867 447.243 179.501 447.243V447.263Z",
    stroke: "url(#paint2_linear_815_8926)",
    strokeWidth: 1.02269,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_815_8926",
    x1: 179.5,
    y1: 0.638428,
    x2: 179.5,
    y2: 467.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#573A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#38134C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E599FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_815_8926",
    x1: 179.505,
    y1: 468.576,
    x2: 179.505,
    y2: -15.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7671D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#37173B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F4899"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_815_8926",
    x1: 179.501,
    y1: 20.8557,
    x2: 179.501,
    y2: 447.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#573A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#38134C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E599FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDungeonInfoModalBackground);
export default __webpack_public_path__ + "static/media/dungeonInfoModalBackground.87c454b712a991462c0e9194a8be4705.svg";
export { ForwardRef as ReactComponent };